import React, { PureComponent } from 'react';

import { ThemeContext } from 'utils/theme';
import HeadingSectionModel from 'models/HeadingSection';

import Heading from './styled/Heading';

export default class HeadingSection extends PureComponent {

  static contextType = ThemeContext;

  render() {
    const { contents } = this.props;

    return (
      <Heading theme={this.context}>
        {contents}
      </Heading>
    );
  }
}
